//Login Actions
export const Login_START = 'Login_START';
export const Login_SUCCESS = 'Login_SUCCESS';
export const Login_FAIL = 'Login_FAIL';
export const LOGIN_LOGOUT = 'LOGIN_LOGOUT';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const FETCH_AVATAR = 'FETCH_AVATAR';
export const ONLINE_AGENTS = 'ONLINE_AGENTS';
export const FETCH_AGENT_WINDOW_SUCCESS = 'FETCH_AGENT_WINDOW_SUCCESS';
export const CHANGE_AGENT_WINDOW_STATE = 'CHANGE_AGENT_WINDOW_STATE';
export const INCREASE_BREAK_SEC = 'INCREASE_BREAK_SEC';
export const CHANGE_AGENT_DIALER_STATE = 'CHANGE_AGENT_DIALER_STATE';
export const FETCH_AGENT_TEMPMSG_SUCCESS = 'FETCH_AGENT_TEMPMSG_SUCCESS';
export const SET_PBX_CONNECTED_STATUS = 'SET_PBX_CONNECTED_STATUS'
export const FETCH_FACEBOOK_LOGIN_SUCCESS = 'FETCH_FACEBOOK_LOGIN_SUCCESS'
export const FETCH_FB_SUBS_PAGES = 'FETCH_FB_SUBS_PAGES'
export const ADD_GROUP = 'ADD_GROUP'
export const REMOVE_GROUP = 'REMOVE_GROUP'
export const ADD_AGENT_TO_GROUP = 'ADD_AGENT_TO_GROUP'
export const REMOVE_AGENT_FROM_GROUP = 'REMOVE_AGENT_FROM_GROUP'
export const REFRESH_MEDIA_TOKEN = 'REFRESH_MEDIA_TOKEN'

//Chat Actions
export const FETCH_MSGS_START = 'FETCH_MSGS_START';
export const FETCH_MSGS_SUCCESS = 'FETCH_MSGS_SUCCESS';
export const FETCH_MSGS_FAIL = 'FETCH_MSGS_FAIL';
export const FETCH_CHAT_UPDATE_CRM_DATA_SUCCESS = 'FETCH_CHAT_UPDATE_CRM_DATA_SUCCESS';
export const SEND_MSGS_START = 'SEND_MSGS_START';
export const SEND_MSGS_SUCCESS = 'SEND_MSGS_SUCCESS';
export const SEND_MSGS_FAIL = 'SEND_MSGS_FAIL';
export const FETCH_CHATS_START = 'FETCH_CHATS_START';
export const FETCH_CHATS_SUCCESS = 'FETCH_CHATS_SUCCESS';
export const FETCH_CHATS_FAIL = 'FETCH_CHATS_FAIL';
export const MULTI_SELECT_UNSELECT_CHAT = 'MULTI_SELECT_UNSELECT_CHAT';
export const MULTI_SELECT_UNSELECT_ALL_CHAT = 'MULTI_SELECT_UNSELECT_ALL_CHAT';
export const SEND_MSG_WITHOUT_SAVING_START = 'SEND_MSG_WITHOUT_SAVING_START';
export const SEND_MSG_WITHOUT_SAVING_SUCCESS = 'SEND_MSG_WITHOUT_SAVING_SUCCESS';
export const SEND_MSG_WITHOUT_SAVING_FAIL = 'SEND_MSG_WITHOUT_SAVING_FAIL';
// export const CHAT_SELECTED ='CHAT_SELECTED';
export const NEW_MSG_RECIVED = 'NEW_MSG_RECIVED';
export const UPDATE_CONVERSATION = 'UPDATE_CONVERSATION';
export const NEW_CONVERSATION = 'NEW_CONVERSATION';
export const UPDATE_MSG_RECIVED = 'UPDATE_MSG_RECIVED';
export const DELETE_MSG_RECIVED = 'DELETE_MSG_RECIVED';
export const CLEAR_MSGS = 'CLEAR_MSGS';
export const UPDATE_CHAT = 'UPDATE_CHAT';
export const FETCH_AGENTS_SUCCESS = 'FETCH_AGENTS_SUCCESS';
export const FETCH_GROUPS_SUCCESS = 'FETCH_GROUPS_SUCCESS'
export const FETCH_COMPANY_EXTS_SUCCESS = 'FETCH_COMPANY_EXTS_SUCCESS';
export const DELETE_CHAT_RECIVED = 'DELETE_CHAT_RECIVED';
export const DELETE_MANY_CHATS = 'DELETE_MANY_CHATS';
export const SET_CATEGORY = 'SET_CATEGORY';
export const INIT_CATEGORY_MSG_UNSEEN_STATUS = 'INIT_CATEGORY_MSG_UNSEEN_STATUS'
export const UPDATE_CATEGORY_MSG_UNSEEN_STATUS = 'UPDATE_CATEGORY_MSG_UNSEEN_STATUS'
export const CHAT_UNSELECT = 'CHAT_UNSELECT'
export const SELECT_MSG = 'SELECT_MSG'

//Dialer Actions
export const CALL_RECEIVED_EVENT = 'CALL_RECEIVED_EVENT';
export const CALL_ANSWERED_EVENT = 'CALL_ANSWERED_EVENT';
export const CALL_RELEASED_EVENT = 'CALL_RELEASED_EVENT';
export const CALL_CONF_START = 'CALL_CONF_START';
export const CLEAR_NOW_CALL = 'CLEAR_NOW_CALL'
export const UPDATE_NOW_CALL = 'UPDATE_NOW_CALL'
export const FETCH_CALLS_SUCCESS = 'FETCH_CALLS_SUCCESS';
export const CALL_DELETED_EVENT = 'CALL_DELETED_EVENT';
export const FETCH_DIAL_LIST_SUCCESS = 'FETCH_DIAL_LIST_SUCCESS';
export const DIAL_LIST_ADDED = 'DIAL_LIST_ADDED';//SOCKETIO
export const DIAL_LIST_UPDATED = 'DIAL_LIST_UPDATED';//SOCKETIO
export const DIAL_LIST_DELETED = 'DIAL_LIST_DELETED';//SOCKETIO
export const DIAL_LIST_AUTO_DELETED = 'DIAL_LIST_AUTO_DELETED';//SOCKETIO
export const DIAL_LIST_POSTPONED_TO_OTHER_AGENT = 'DIAL_LIST_POSTPONED_TO_OTHER_AGENT';//SOCKETIO
export const DIAL_LIST_ADD = 'DIAL_LIST_ADD';
export const DIAL_LIST_UPDATE = 'DIAL_LIST_UPDATE';
export const DIAL_LIST_DELETE = 'DIAL_LIST_DELETE';
export const DIAL_LIST_DETAILS_UPDATE = 'DIAL_LIST_DETAILS_UPDATE';
export const MULTI_SELECT_UNSELECT_CALLS = 'MULTI_SELECT_UNSELECT_CALLS';
export const MULTI_SELECT_UNSELECT_ALL_CALLS = 'MULTI_SELECT_UNSELECT_ALL_CALLS';
export const MULTI_SELECT_UNSELECT_DIALLIST = 'MULTI_SELECT_UNSELECT_DIALLIST';
export const MULTI_SELECT_UNSELECT_ALL_DIALLIST = 'MULTI_SELECT_UNSELECT_ALL_DIALLIST';
export const CALL_DETAILS_UPDATE = 'CALL_DETAILS_UPDATE'
export const CLEAR_DIALER_STATE = 'CLEAR_DIALER_STATE'
export const HOLD_STATUS_CHANGED = 'HOLD_STATUS_CHANGED'
// Settings Actions
export const FETCH_SETTINGS_SUCCESS = 'FETCH_SETTINGS_SUCCESS';
export const SET_SETTING = 'SET_SETTING';
export const CLEAR_SETTINGS_STATE = 'CLEAR_SETTINGS_STATE'


// NOTIFICATION ACTION TYPES
export const CLEAR_NOTIFICATIONS_STATE = 'CLEAR_NOTIFICATIONS_STATE'
export const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS'
export const ADD_NEW_NOTIFICATIONS = 'ADD_NEW_NOTIFICATIONS'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'
export const DELETE_NOTIFICATION = 'DELETE_NOTIFICATION'

// Contacts
export const FETCH_CONTACTS_SUCCESS = 'FETCH_CONTACTS_SUCCESS';
export const FETCH_CONTACTS_START = 'FETCH_CONTACTS_START';
export const FETCH_CONTACTS_FAIL = 'FETCH_CONTACTS_FAIL';
export const SELECT_CONTACT_SUCCESS = 'SELECT_CONTACT_SUCCESS';
export const INSERT_NEW_CONTACT = 'INSERT_NEW_CONTACT';
export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const DELETE_CONTACT = 'DELETE_CONTACT'

// Chat/Contact
export const INSERT_CHAT_CONTACT = 'INSERT_CHAT_CONTACT';
export const UPDATE_CHAT_CONTACT = 'UPDATE_CHAT_CONTACT';
export const DELETE_CHAT_CONTACT = 'DELETE_CHAT_CONTACT'
// Call/Contact
export const INSERT_CALL_CONTACT = 'INSERT_CALL_CONTACT';
export const UPDATE_CALL_CONTACT = 'UPDATE_CALL_CONTACT';
export const DELETE_CALL_CONTACT = 'DELETE_CALL_CONTACT'
// DialList/Contact
export const INSERT_DIALLIST_CONTACT = 'INSERT_DIALLIST_CONTACT';
export const UPDATE_DIALLIST_CONTACT = 'UPDATE_DIALLIST_CONTACT';
export const DELETE_DIALLIST_CONTACT = 'DELETE_DIALLIST_CONTACT'

//CRM
export const INIT_CRM_MODULE_LIST = 'INIT_CRM_MODULE_LIST'
export const SET_ROUTE_PARAMS = 'SET_ROUTE_PARAMS';
export const UPDATE_QUERY_PARAMS = 'UPDATE_QUERY_PARAMS'
export const UPDATE_DASHBOARD_SECTION = 'UPDATE_DASHBOARD_SECTION'
export const SET_CRM_MODULE = 'SET_CRM_MODULE'
export const START_CRM_LOADING = 'START_CRM_LOADING'
export const FINISH_CRM_LOADING = 'FINISH_CRM_LOADING'
export const CHANGE_CRM_MODULE_ORDER = 'CHANGE_CRM_MODULE_ORDER'
export const CLEAR_PENDING_MODULE_ORDER = 'CLEAR_PENDING_MODULE_ORDER'
export const CLEAR_CRM_ALERT = 'CLEAR_CRM_ALERT'
export const ADD_OR_UPDATE_NAV_PATH = 'ADD_OR_UPDATE_NAV_PATH';
export const DELETE_MODULE = 'DELETE_MODULE'